import {
  useCallback, useEffect, useState,
} from 'react';

type Options = {
  rootMargin?: string;
  triggerOnce?: boolean;
};

export function useInView(options: Options = {}) {
  const { rootMargin = '500px 0px', triggerOnce = true } = options;
  const [node, setNode] = useState<HTMLElement | null>(null);
  const [inView, setInView] = useState(false);

  const ref = useCallback((element: HTMLElement | null) => {
    setNode(element);
  }, []);

  useEffect(() => {
    if (!node) return undefined;
    if (triggerOnce && inView) return undefined;

    if (typeof IntersectionObserver === 'undefined') {
      setInView(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          if (triggerOnce) observer.disconnect();
        } else if (!triggerOnce) {
          setInView(false);
        }
      },
      { rootMargin, threshold: 0 },
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [inView, node, rootMargin, triggerOnce]);

  return { ref, inView };
}
